var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEleviaicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 46,
    viewBox: "0 0 47 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.8128 24.4238C46.4738 21.5529 44.7268 18.6792 41.9107 18.0052C39.0946 17.3313 36.2759 19.1124 35.6149 21.9834C34.9538 24.8544 36.7009 27.7281 39.5169 28.402C42.333 29.0759 45.1518 27.2948 45.8128 24.4238Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3618 30.9227C35.3012 30.2953 34.3846 29.4677 33.6644 28.4665L22.0632 40.2938L6.91358 24.8489H32.1324C32.0408 24.3149 31.9753 23.7676 31.9753 23.2069C31.9753 22.4994 32.0539 21.8186 32.211 21.1645H6.91358L22.0632 5.70617L33.8346 17.7071C34.581 16.7326 35.5368 15.9183 36.6105 15.3309L22.0632 0.5L0 22.9933L22.0632 45.4867L36.3618 30.9094V30.9227Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEleviaicon);
export default __webpack_public_path__ + "static/media/elevia icon.aa29002d9492911abe43c54029e03c13.svg";
export { ForwardRef as ReactComponent };